import { Content } from '@amzn/awscat-pattern-library-service-model';

import { deepCloneContent } from '../../model/CloneContent';
import { log } from '../../loggers/Logger';
import { SyncAdhocMigration } from '../AdhocMigration';

/** Section id as defined in the Pattern template (Pattern-v1.json / Pattern-v2.json). */
const TROUBLESHOOTING_SECTION_ID = 'troubleshooting';

/**
 * In older versions of APG, troubleshooting was a single object instead of
 * an array. This migration converts that to an array.
 */
export class TroubleshootingArrayMigration implements SyncAdhocMigration {
  readonly kind = 'sync' as const;
  readonly name = 'troubleshooting-array';

  private logger = log.child({ class: this.constructor.name, migration: this.name });

  apply(content: Content): Content {
    // Bail early if content has no sections at all.
    const sections = content.contentData?.contentSections;
    if (!sections) {
      this.logger.info('Skipping: content has no contentSections');
      return content;
    }

    // Locate the troubleshooting section by its stable id.
    const idx = sections.findIndex((section) => section.id === TROUBLESHOOTING_SECTION_ID);
    if (idx === -1) {
      this.logger.info('Skipping: no troubleshooting section found');
      return content;
    }

    // Already migrated or empty — nothing to do.
    const section = sections[idx];
    // @ts-expect-error TS18048 - strict migration
    if (Array.isArray(section.contentData)) {
      this.logger.info('Skipping: troubleshooting contentData is already an array');
      return content;
    }
    // @ts-expect-error TS18048 - strict migration
    if (section.contentData == null) {
      this.logger.info('Skipping: troubleshooting contentData is null/undefined');
      return content;
    }

    // Wrap the single legacy object into a one-element array.
    const updated = deepCloneContent(content);
    const clonedSection = updated.contentData.contentSections[idx];
    // @ts-expect-error TS18048 - strict migration
    clonedSection.contentData = [clonedSection.contentData];

    this.logger.info('Wrapped legacy single-object troubleshooting into a one-element array');
    return updated;
  }
}
